import React, { Component } from 'react';
import GreeksRow from './GreeksRow';
import './PerformanceTable.css';
import i18n from '../../../i18n';

class GreeksTable extends Component {

  // create the rows
  renderRows() {
    const {
      data,
      type,
    } = this.props;

    return data.map((fund) => {
      return (
        <GreeksRow key={fund.externalID} fund={fund} type={type} />
      );
    });
  }

  // create the header
  renderHeader(title) {
    const {
      type,
      data,
    } = this.props;

    const hasData = data.filter((e) => e[type]);
    const asOfDate = new Date(hasData[0][type].asOfDate).toLocaleDateString();
    const commonStartDate = new Date(hasData[0][type].commonPeriodNAVStart).toLocaleDateString();
    const commonEndDate = new Date(hasData[0][type].commonPeriodNAVEnd).toLocaleDateString();
    return (
      <thead>
        <tr>
          <th colSpan='9' className='textLeft'>{title.toUpperCase()} {i18n.t('as of')} {asOfDate}</th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>{i18n.t('Ticker')}</th>
          <th scope='col' className='textLeft'>{i18n.t('Fund')}</th>
          <th scope='col' className='textCenter'>{i18n.t('Inception')}<br /> {i18n.t('Date')}</th>
          <th scope='col' className='borderleft textCenter'>{i18n.t('1-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('3-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('5-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('10-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('Since Inception')}</th>
          <th scope='col' className='textCenter'>{i18n.t('Common Period')} <br /> {commonStartDate} -  {commonEndDate}  </th>
        </tr>
      </thead>
    );
  }


  render() {
    const {
      type,
      data,
      title,
    } = this.props;

    if ((data === null) || (type === null) || (title === null)) {
      return null;
    }

    const hasData = data.filter((e) => e[type]);
    if (hasData.length > 0) {
      let bmkName = `(${hasData[0][type].bmkName})`;
      if (type === 'sharpeRatio') {
        bmkName = '';
      }
      return (
        <div>
          {/* <div className={s.heading}>{i18n.t(title)} {bmkName}</div> */}
          <div className='table-responsive'>
            <table className='tableFC'>
              {this.renderHeader(`${i18n.t(title)} ${bmkName}`)}
              <tbody>{this.renderRows()}</tbody>
            </table>
          </div>
          {type === 'alpha' &&
            <div className='fund-char-perf-definitions'> 
              <strong>{i18n.t('AlphaKey')}</strong> : {i18n.t('AlphaDefinition')}
            </div>          
          }
          {type === 'beta' &&
            <div className='fund-char-perf-definitions'> 
              <strong>{i18n.t('BetaKey')}</strong> : {i18n.t('BetaDefinition')}
            </div>                 
          }
          {type === 'sharpeRatio' &&
            <div className='fund-char-perf-definitions'> 
              <strong>{i18n.t('SharpeRatioKey')}</strong> : {i18n.t('SharpeRatioDefinition')}
            </div>             
          }
          {type === 'upCapture' &&
            <div className='fund-char-perf-definitions'> 
              <strong>{i18n.t('UpCaptureKey')}</strong> : {i18n.t('UpCaptureDefinition')}
            </div>
          }
          {type === 'downCapture' &&
            <div className='fund-char-perf-definitions'> 
              <strong>{i18n.t('DownCaptureKey')}</strong> : {i18n.t('DownCaptureDefinition')}
            </div>
          }
        </div>
      );
    } else {
      return null;
    }
  };
}

export default (GreeksTable);
